import { render, staticRenderFns } from "./CountryLocaleModal.vue?vue&type=template&id=47b4ffbd&scoped=true&"
import script from "./CountryLocaleModal.vue?vue&type=script&lang=js&"
export * from "./CountryLocaleModal.vue?vue&type=script&lang=js&"
import style0 from "./CountryLocaleModal.vue?vue&type=style&index=0&id=47b4ffbd&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4ffbd",
  null
  
)

export default component.exports